import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const ACCIDENT_IN_POLAND = {
  YES: 'yes',
  NO: 'no',
} as const;

export const ACCIDENT_IN_POLAND_NAME = 'accident_in_poland';
export const ACCIDENT_IN_POLAND_NAME_COMPLEMENTARY =
  'accident_in_poland_complementary';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioGroupAccidentInPoland: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  const fieldName =
    name ??
    (isComplementary
      ? ACCIDENT_IN_POLAND_NAME_COMPLEMENTARY
      : ACCIDENT_IN_POLAND_NAME);

  return (
    <FormField
      control={control}
      name={fieldName}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{i18n.t('Czy szkoda miała miejsce w Polsce?')}</FormLabel>
          <FormControl>
            <RadioGroup
              {...field}
              layout={'horizontal'}
              data-testid="radio-group-accident-in-poland"
            >
              <RadioItem
                value={ACCIDENT_IN_POLAND.YES}
                label={i18n.t('Tak')}
                data-testid="radio-item-accident-in-poland-yes"
              />
              <RadioItem
                value={ACCIDENT_IN_POLAND.NO}
                label={i18n.t('Nie')}
                data-testid="radio-item-accident-in-poland-no"
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
